import Loadable from 'react-loadable';
import { ModuleLoadingPage } from '@agora/agora-common/Loading';

const Control = Loadable({
  loader: () => import('./ControlContainer'),
  timeout: 60000,
  loading: ModuleLoadingPage,

});

export default Control;
